import { authService } from "@/services/apiServices";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/css'

import { vMaska } from "maska/vue";
import RegisterSuccess from "@/components/RegisterSuccess.vue";
export default {
  name: "AuthForm",
  components: {
    RegisterSuccess
  },
  directives: {
    maska: vMaska
  },
  props: {
    initialTab: {
      type: String,
      default: "login"
    }
  },
  data() {
    return {
      activeTab: this.initialTab,
      tabs: [{
        label: "Кіру",
        value: "login"
      }, {
        label: "Тіркелу",
        value: "register"
      }],
      usernameUnmasked: "",
      usernameMasked: "",
      form: {
        password: "",
        email: "",
        full_name: ""
      },
      isLoading: false,
      showRegisterSuccess: false
    };
  },
  computed: {
    buttonText() {
      return this.activeTab === "login" ? "Кіру" : "Тіркелу";
    }
  },
  methods: {
    onInputFocus() {
      if (this.usernameMasked.length === 0) {
        this.usernameMasked = "+7 (";
      }
    },
    close() {
      this.$emit("closeAuthForm");
    },
    async login() {
      if (this.isLoading) return;
      if (this.usernameUnmasked.length !== 10) {
        ElMessage.error("Телефон нөмірін дұрыс енгізіңіз");
        return;
      }
      if (this.form.password.length < 6) {
        ElMessage.error("Құпия сөз 6 символдан кем болмауы тиіс");
        return;
      }
      this.isLoading = true;
      const error = await this.$store.dispatch("login", {
        username: "8" + this.usernameUnmasked,
        password: this.form.password
      });
      this.isLoading = false;
      if (error) {
        ElMessage.error("Кіру сәтсіз аяқталды");
      } else {
        this.close();
        window.location.reload();
      }
    },
    async register() {
      if (this.isLoading) return;
      if (this.usernameUnmasked.length !== 10) {
        ElMessage.error("Телефон нөмірін дұрыс енгізіңіз");
        return;
      }
      if (this.form.full_name.length < 3) {
        ElMessage.error("Аты жөнін дұрыс енгізіңіз");
        return;
      }
      if (this.form.email.length < 3) {
        ElMessage.error("E-mail дұрыс енгізіңіз");
        return;
      }
      if (this.form.password.length < 6) {
        ElMessage.error("Құпия сөз 6 символдан кем болмауы тиіс");
        return;
      }
      try {
        this.isLoading = true;
        const response = await authService.register({
          ...this.form,
          username: "8" + this.usernameUnmasked
        });
        console.log(response);
        if (response.responseStatus === 201) {
          this.showRegisterSuccess = true;
          this.form = {
            password: "",
            email: "",
            full_name: ""
          };
          this.usernameUnmasked = "";
          this.usernameMasked = "";
          // this.close();
        }
      } catch (error) {
        console.log(error);
        let errorMessage = "Тіркелу барысында қателер пайда болды";
        if (error.message) {
          errorMessage = error.message;
        }
        const errorData = error.response.data;
        if (errorData && typeof errorData === "object") {
          const errorKeys = Object.keys(errorData);
          if (errorKeys.length > 0) {
            const firstKey = errorKeys[0];
            if (Array.isArray(errorData[firstKey])) {
              errorMessage = errorData[firstKey][0];
            } else {
              errorMessage = errorData[firstKey];
            }
          }
        }
        ElMessage.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
    handleCloseRegisterSuccess() {
      this.showRegisterSuccess = false;
      this.activeTab = "login";
    }
  }
};